import styled from 'styled-components';


export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => props.theme.white1};
  height: 100vh;
`;
export const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 40px);
  overflow: auto;
  margin-left: 0;
`;
